<template>
    <a-file-window
        ref="aFileWindow"
        :AFileConfig="AFileConfig"
        :pageWidth="afilePageWidth"
        :pageHeight="afilePageHeight"
        @pointerdown="focusWindow()"
        @onChangeSize="resizeAfile"
        @closeAFile="handleCloseAFile"
    >
        <video ref="afileVideo" :id="getID" :style="videoStyle" class="afile-movie" @click="JudgePlay()" autoplay crossorigin>
            <source :src="videoSrc" type="video/mp4" />
            <track :label="subtitlesLang" kind="subtitles" :srclang="subtitlesLang" :src="subtitleSrc" default />
        </video>
        <template v-slot:toolbar>
            <div ref="movie_tool" class="movieTool" :style="fontStyle">
                <img class="leftExit" src="@/assets/player/close.svg" alt="" @click.stop="closeAFile" draggable="false" />
                <img ref="playBtn" class="play-btn" alt="" @click="JudgePlay()" draggable="false" />
                <img class="button" src="@/assets/player/stop.svg" alt="" @click="stop()" draggable="false" />
                <input
                    class="timeline linebar"
                    type="range"
                    min="0"
                    max="100"
                    v-model="timeline"
                    :style="{ backgroundSize: timeStyle }"
                    @mousedown="videoPause()"
                    @mouseup="setCurrentTime(timeline), videoPlay()"
                    @touchstart.stop.passive="videoPause()"
                    @touchend.stop.passive="setCurrentTime(timeline), videoPlay()"
                    @input="setCurrentTime(timeline)"
                />
                <span>{{ currentTime }}</span>
                <span>/</span>
                <span>{{ durationTime }}</span>
                <div class="sound-parent">
                    <CustomDivSelect v-show="menuSound">
                        <div class="soundline-parent">
                            <div class="soundline-text">
                                <text>{{ volume }}</text>
                            </div>
                            <div class="soundline-bar-parent">
                                <br />
                                <br />
                                <br />
                                <br />
                                <input
                                    class="soundline linebar"
                                    type="range"
                                    min="0"
                                    max="100"
                                    v-model="volume"
                                    @input="setVolume(volume)"
                                    :style="{ backgroundSize: volumeStyle }"
                                />
                            </div>
                        </div>
                    </CustomDivSelect>
                    <img
                        class="button"
                        :class="{ volume: volumeIconSrc, 'no-volume': !volumeIconSrc }"
                        src="@/assets/player/sound100.svg"
                        alt=""
                        @click="toggleSoundMenu()"
                        draggable="false"
                    />
                </div>
                <div class="subtitles-parent">
                    <CustomDivSelect v-show="menuSubtitles">
                        <div
                            v-for="data of subtitlesData"
                            :key="data.value"
                            @click="setSubtitles(data.value)"
                            :class="{ active: data.value == subtitlesLang, 'padding-color': data.value == subtitlesLang, 'empty-div': !data.display }"
                        >
                            <div v-if="data.display">
                                <text v-show="data.value == subtitlesLang">√</text>
                                <text>{{ data.name }}</text>
                                <text v-if="data.nbsp">&nbsp;&nbsp;&nbsp;&nbsp;</text>
                            </div>
                        </div>
                    </CustomDivSelect>
                    <img class="button" src="@/assets/player/captions.svg" alt="" @click="toggleSubtitlesMenu()" draggable="false" />
                </div>
                <div class="speed-parent">
                    <CustomDivSelect v-show="menuSpeed">
                        <div
                            v-for="data of speedData"
                            :key="data.value"
                            @click="setSpeed(data.value)"
                            class="menu-speed"
                            :class="{ active: data.value == currentSpeed, 'padding-color': data.value == currentSpeed }"
                        >
                            <text v-show="data.value == currentSpeed">√</text>
                            <text>{{ data.name }}</text>
                        </div>
                    </CustomDivSelect>
                    <img class="button" src="@/assets/player/speed.svg" alt="" @click="toggleSpeedMenu()" draggable="false" />
                </div>
                <img v-if="isInvisibleFullScreen" class="button" src="@/assets/player/screenFull.svg" alt="" @click="switchScreen(0.5)" draggable="false" />
                <img class="rightExit" src="@/assets/player/close.svg" alt="" @click="closeAFile" draggable="false" />
                <video :id="getID" type="video/mp4" style="display: none" crossorigin>
                    <track ref="testTrackSrc" default />
                </video>
            </div>
        </template>
    </a-file-window>
</template>

<script>
import BookData from "@/js/book_data";
import EventBus from "@/js/event_bus.js";
import ToolMath from "@/js/tool_math.js";
import AFileWindow from "@/components/AFile/AFileWindow";
import CustomDivSelect from "@/components/common/CustomDivSelect";
import { focusStore } from "@/js/store/nowFocusStore";
import { settingStore } from "../../js/store/settingStore";
import { store } from "../../store";
import { VIEW_TYPE } from "@/js/view_type";

export default {
    name: "AFileMovie",
    data: function () {
        return {
            window: null,
            extraCloseBtn: HTMLDivElement,
            extraWindowBtn: HTMLDivElement,
            video: HTMLVideoElement,
            currentId: "",
            afilePageWidth: 0,
            afilePageHeight: 0,
            isPlay: false,
            currentTime: "00:00",
            durationTime: "00:00",
            timeline: 0,
            timeStyle: `0% 100%`,
            volume: 100,
            volumeStyle: `100% 100%`,
            speedData: [
                {
                    name: "0.5倍",
                    nbsp: 1,
                    value: "0.5",
                },
                {
                    name: "0.75倍",
                    nbsp: 0,
                    value: "0.75",
                },
                {
                    name: "正常",
                    nbsp: 2,
                    value: "1",
                },
                {
                    name: "1.25倍",
                    nbsp: 0,
                    value: "1.25",
                },
                {
                    name: "1.5倍",
                    nbsp: 1,
                    value: "1.5",
                },
            ],
            currentSpeed: 1,
            subtitlesData: [
                {
                    name: "無字幕",
                    nbsp: false,
                    value: "no",
                    display: true,
                },
                {
                    name: "中文",
                    nbsp: true,
                    value: "tw",
                    display: true,
                },
                {
                    name: "英文",
                    nbsp: true,
                    value: "en",
                    display: true,
                },
                {
                    name: "中英文",
                    nbsp: false,
                    value: "entw",
                    display: true,
                },
            ],
            subtitlesLang: "no",
            tempSubtitlesLang: "no",
            emptySubtitlesArr: [],
            menuSpeed: false,
            menuSubtitles: false,
            menuSound: false,
            fakePageItemControl: {},
            store,
            VIEW_TYPE,
        };
    },
    props: ["AFileConfig"],
    components: {
        AFileWindow,
        CustomDivSelect,
    },
    methods: {
        closeAFile: function () {
            //手動還原原本版型的關閉按鈕
            this.extraCloseBtn.setAttribute("style", "display:block;");
            this.extraWindowBtn.setAttribute("style", "display:block;");

            this.fakePageItemControl = null;
            focusStore.setNowPageItemControl();
            window.soundManager.audioPlayerStop();
            EventBus.getInstance().emit("removeAfile", this.AFileConfig);
        },
        JudgePlay: function () {
            this.closeAllMenu();

            if (this.isPlay) this.videoPause();
            else this.videoPlay();
        },
        videoPlay: function () {
            this.video.addEventListener("timeupdate", this.changeTimeLinePosition);
            this.video.play();
            this.isPlay = true;
            this.$refs.playBtn.setAttribute("class", "play-btn");
        },
        videoPause: function () {
            this.video.removeEventListener("timeupdate", this.changeTimeLinePosition);
            this.video.pause();
            this.isPlay = false;
            this.$refs.playBtn.setAttribute("class", "pause-btn");
        },
        stop: function () {
            this.videoPause();
            this.video.pause();
            this.video.currentTime = 0;
            this.setCurrentTime(0);
        },
        setCurrentTime: function (value) {
            this.video.currentTime = (value / 100) * this.video.duration;
            this.changeTimeLinePosition();
        },
        changeTimeLinePosition: function () {
            const percentagePosition = (100 * this.video.currentTime) / this.video.duration;
            this.currentTime = ToolMath.Instance.getDisplayTime(this.video.currentTime);
            this.timeline = percentagePosition;
            this.timeStyle = `${percentagePosition}% 100%`;
            if (this.video.currentTime == this.video.duration) this.videoPause();
        },
        toggleSpeedMenu: function () {
            const tempBool = this.menuSpeed;
            this.closeAllMenu();
            this.menuSpeed = !tempBool;
        },
        toggleSubtitlesMenu: function () {
            const tempBool = this.menuSubtitles;
            this.closeAllMenu();
            this.menuSubtitles = !tempBool;
        },
        toggleSoundMenu: function () {
            const tempBool = this.menuSound;
            this.closeAllMenu();
            this.menuSound = !tempBool;
        },
        closeAllMenu: function () {
            this.menuSpeed = false;
            this.menuSubtitles = false;
            this.menuSound = false;
        },
        setSpeed: function (num) {
            this.menuSpeed = false;
            this.currentSpeed = num;
            this.video.playbackRate = num;
        },
        setSubtitles: function (data) {
            this.menuSubtitles = false;
            this.subtitlesLang = data;
        },
        subtitlesPreLoad: function (path) {
            this.tempSubtitlesLang = path;
            this.$refs.testTrackSrc.src = BookData.Instance.getBookPath() + this.AFileConfig.fileName.split(".mp4")[0] + "_" + this.tempSubtitlesLang + ".vtt";
        },
        /**設定音量 */
        setVolume: function (value) {
            store.movieVolume = value;
            this.volume = value;
            this.volumeStyle = `${value}% 100%`;
            this.video.volume = value / 100;
        },
        switchScreen: function () {
            this.video.webkitRequestFullScreen();
        },
        resizeAfile: function () {
            this.afilePageWidth = this.$refs.afileVideo.clientWidth;
            this.afilePageHeight = this.$refs.afileVideo.clientHeight;
        },
        focusWindow() {
            this.$refs.aFileWindow.setFocusPainter();
            setTimeout(() => {
                focusStore.setNowPageItemControl(this.fakePageItemControl, this.AFileConfig.type);
            });
        },
    },
    computed: {
        videoSrc() {
            return BookData.Instance.getBookPath() + this.AFileConfig.fileName;
        },
        subtitleSrc() {
            if (this.subtitlesLang == "no") return;
            return BookData.Instance.getBookPath() + this.AFileConfig.fileName.split(".mp4")[0] + "_" + this.subtitlesLang + ".vtt";
        },
        volumeIconSrc() {
            if (this.volume > 0) return true;
            else return false;
        },
        getID() {
            this.currentId = "video" + new Date().getTime();
            return this.currentId;
        },
        fontStyle() {
            return { "font-size": Math.floor(this.afilePageWidth / 100) * 2 + "px" };
        },
        videoStyle() {
            return {
                transform: settingStore.isFixed == 0 ? "" : "scale(" + this.store.contentScaleY / this.store.contentScaleX + "," + 1 + ")",
            };
        },
        isMute() {
            return this.volume == 0;
        },
        isInvisibleFullScreen() {
            return !(store.nowView == VIEW_TYPE.ANDROID || store.nowView == VIEW_TYPE.IOS);
        },
    },
    mounted() {
        window.soundManager.audioPlayerStop();
        this.video = document.getElementById(this.currentId);

        //進入後才切換成play，預先載入停止的按鈕避免版型跳動
        this.videoPlay();

        //預先讀取字幕檔，為了讓沒有字幕的選項先關閉
        this.$refs.testTrackSrc.addEventListener("error", () => {
            this.emptySubtitlesArr.push(this.tempSubtitlesLang);
            // if (this.tempSubtitlesLang != "no") {
            //     this.subtitlesData.forEach((element) => {
            //         if (element.value == this.tempSubtitlesLang) element.display = false;
            //     });
            // }
            this.tempSubtitlesLang = "no";
        });

        for (let i = 1, max = this.subtitlesData.length; i < max; i++) {
            setTimeout(this.subtitlesPreLoad.bind(null, this.subtitlesData[i].value), 100 * i);
        }
        //禁用子母畫面
        this.video.disablePictureInPicture = true;

        this.video.addEventListener("canplaythrough", () => {
            this.durationTime = ToolMath.Instance.getDisplayTime(this.video.duration);
        });

        document.documentElement.style.setProperty("--window-devicePixelRatio", window.devicePixelRatio);

        //手動隱藏原本版型的關閉按鈕
        this.extraCloseBtn = document.getElementsByClassName("close-btns tools")[0];
        this.extraWindowBtn = document.getElementsByClassName("window-btns tools windowed")[0];
        this.extraCloseBtn.setAttribute("style", "display:none;");
        this.extraWindowBtn.setAttribute("style", "display:none;");

        setTimeout(() => {
            this.resizeAfile();
            this.setVolume(store.movieVolume);

            if (BookData.Instance.isSubjectEN()) {
                if (this.subtitlesData.findIndex((data) => data.value == "en")) {
                    this.setSubtitles("en");
                }
            }
        }, 100);
        this.focusWindow();
    },
    watch: {
        isMute: {
            handler: function () {
                this.$refs.afileVideo.muted = this.isMute ? "muted" : "";
            },
        },
    },
};
</script>

<style scoped>
.afile-root {
    background-color: #272727;
    /* min-width: 640px;
    min-height: 480px; */
}

.windowscale-handle {
    transform: scale(calc(1 / var(--window-devicePixelRatio)));
    white-space: nowrap;
}

.play-btn {
    content: url("@/assets/player/pause.svg");
}

.pause-btn {
    content: url("@/assets/player/play.svg");
}

.volume {
    content: url("@/assets/player/sound100.svg");
}

.no-volume {
    content: url("@/assets/player/sound0.svg");
}

.afile-movie {
    position: absolute;
    width: 100%;
    height: 96%;
    top: 0px;
    left: 0px;
}

.movieTool {
    position: absolute;
    bottom: 1%;
    /* left: 2.5%; */
    left: 32px;
    height: 5%;
    /* width: 95%; */
    width: calc(100% - 64px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 4;
    /* transform: scale(calc(1 / var(--window-devicePixelRatio))); */
}

/* .movieTool * {
    font-size: 28px;
    font-size: min(max(1.5vw, 16px), 28px);
} 
*/

.movieTool > * {
    /* margin-left: calc(10px / var(--window-devicePixelRatio)); */
    margin-left: 10px;
}

.movieTool img {
    height: 100%;
}

.movieTool > text,
.movieTool > span {
    color: #ffffff;
}
.subtitles-parent {
    height: 100%;
}

.speed-parent {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.speed-parent * {
    margin-left: 0px;
}

.menu-speed {
    width: 130px;
    display: flex;
    align-items: flex-start;
}

/* 播放條CSS */
.linebar {
    outline: none;
    cursor: pointer;
    background-color: #9d9d9d;
    background-size: 0% 100%;
    background-image: linear-gradient(#46a3ff, #46a3ff);
    background-repeat: no-repeat;
}

.timeline {
    -webkit-appearance: none;
    width: 55%;
    height: 0.8em;
    border-radius: 50px;
}
.sound-parent {
    height: 100%;
}
.soundline-parent {
    position: absolute;
    bottom: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
}

.soundline-bar-parent {
    display: flex;
    justify-content: center;
    height: 100px;
}

.soundline {
    -webkit-appearance: none;
    height: 0.8em;
    position: absolute;
    /* top: calc(105px - 30px * var(--window-devicePixelRatio)); */
    top: 75px;
    padding: 0px;
    border-radius: 50px;
    transform: rotate(-90deg);
}

.soundline-text {
    position: relative;
    display: flex;
    justify-content: center;
    width: 3vw;
    font-size: 28px !important;
    padding-bottom: 0px;
    height: 50px;
}

.soundline-text * {
    padding-bottom: 0px;
}

input[type="range"]::-webkit-slider-thumb,
input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 1em;
    height: 1em;
    border-radius: 100%;
    cursor: pointer;
    transition: all 0.2s;
    background-color: #ffffff;
    box-shadow: 0px 0px 15px rgba(77, 68, 68, 0.7);
}

input[type="range"]::-webkit-slider-thumb:hover,
input[type="range"]::-webkit-slider-thumb:hover {
    width: 1em;
    height: 1em;
    background-color: #ffffff;
    box-shadow: 0px 0px 15px rgba(77, 68, 68, 0.7);
}

.active * {
    background-color: #46a3ff;
    color: #ffffff;
}

.padding-color {
    background: #46a3ff;
}

.empty-div {
    padding: 0px;
}

/**字幕css */
/* ::cue {
    color: #000000;
}
::cue(v[voice="Test"]) {
    color: #FFFFFF;
    background: #0095dd;
    font-size: 12px;
} */
</style>
